import { APP_INJECTOR } from 'app.module'
import { Authentication, Authorization } from 'core/auth'
import { AlertService } from 'core/alert'
import { ConfirmService } from 'core/confirm'
import { CurrentUser } from 'models'
import { WebviewLogService } from 'pages/webview/webview-log.service'

export abstract class BaseComponent {
  protected authentication: Authentication
  protected authorization: Authorization
  protected alertService: AlertService
  protected confirmService: ConfirmService
  protected logService: WebviewLogService

  constructor() {
    this.authentication = APP_INJECTOR.get(Authentication)
    this.authorization  = APP_INJECTOR.get(Authorization)
    this.alertService   = APP_INJECTOR.get(AlertService)
    this.confirmService = APP_INJECTOR.get(ConfirmService)
    this.logService = APP_INJECTOR.get(WebviewLogService)
  }

  ngOnInit() {}

  ngOnDestroy() {}

  protected currentUser(): CurrentUser {
    return this.authentication.currentUser
  }

  protected allowed(scope: string, action: string, targetObject?: any): boolean {
    return this.authorization.allowed(this.currentUser(), scope, action, targetObject)
  }

  protected driverEvent(event: string, data: object) {
    this.logService.driverEvent(event, data)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/abstract-components/base.component.ts